<template>
    <div id="editor">
        <quill-editor
            class="editor"
            v-model="editorContents"
            ref="myQuillEditor"
            :options="editorOption"
            @blur="onEditorBlur($event)"
            @focus="onEditorFocus($event)"
            @change="onEditorChange($event)"
        >
        </quill-editor>
    </div>
</template>
<script>
import { quillEditor } from "vue-quill-editor";
export default {
    props: ["answers"],
    data() {
        return {
            editorContents: null,
            editorOption: {},
        };
    },
    methods: {
        onEditorBlur() {},
        onEditorFocus() {
            //获得焦点事件
        },
        onEditorChange() {
            //内容改变事件
          
        },
        escapeStringHTML(str) {
            //转码
            str = str.replace(/&lt;/g, "<");
            str = str.replace(/&gt;/g, ">");
            return str;
        },
    },
    // mounted() {
    //     if (this.answers) this.editorContents = this.answers;
    // },
    watch: {
        answers: {
            handler: function (newValue, oldValue) {
                this.editorContents = newValue;
            },
        },
    },
};
</script>
<style lang="less" scoped>
.editor {
    width: 100%;
}
</style>